// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".date-picker-custom-popup-class .mx-week-number{font-size:8.3px;font-weight:700}.date-picker-custom-popup-class .mx-week-number:before{content:\"W-\"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
